import { Box, Checkbox, FormControlLabel, IconButton, InputAdornment, InputLabel, ListItemText, MenuItem, Paper, Select, TextField } from '@mui/material';
import { makeStyles } from "@mui/styles";
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List } from "react-window";
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg";
import CancelButton from "../../../assets/icons/icon-cancel.svg";
import { ReactComponent as InputSearchIcon } from "../../../assets/icons/icon-feather-search.svg";
import Loader from '../../../pages/Loader';
import getDataFromCube from '../../../utils/getCubeData';

const useStyles = makeStyles({
    header: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        marginTop: '-8px',
    },
    search: {
        marginBottom: "1px",
    },
    card: {
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        display: 'flex',
        backgroundColor: "#fff4f0",
    }
});

export default function FilterMultipleSelectValue({ filterCondtion, i, handleChangeFilterFromList, reportIndex, reportDetails, updateReportDetails, from, onLoader = true }) {
    const [fechData, setFechData] = useState([]);
    const [searchData, setSearchData] = useState([])
    const classes = useStyles();
    const [searchLoader, setSearchLoader] = useState(false)
    const [filterInputOpen, setFilterInputOpen] = React.useState(false);

    const handleFilterInputClose = (e, type) => {
        e?.stopPropagation();
        //setFilterInputEl(null);
        setFilterInputOpen(false);
        setSearchData([])
        setSearchLoader(false)

        return false;
    };

    const handleChangeFilterFromListHandler = (filterCondtion, i, e, reportIndex) => {
        let allDeselected = false;
        if (filterCondtion?.selectAll && e?.target?.value === "all") {
            if (filterCondtion?.dynamicLabel) {
                e.target.value = (searchData?.length ? searchData : fechData)?.map(e => e && e?.[Object.keys(e)?.filter(p => p !== filterCondtion?.dynamicLabel?.label)])
            } else {
                e.target.value = (searchData?.length ? searchData : fechData)
            }
        }
        else if (filterCondtion?.selectAll && e?.target?.value === null) {
            e.target.value = []
            allDeselected = true;
        }

        e.target.value = typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value;
        if (e.target.value.length === 0) allDeselected = true;
        if (from === 'dashboard') {
            let promiseArr = []
            reportDetails[reportIndex].reportFilters[i].values = e.target.value;

            const relevantParent = reportDetails[reportIndex].reportFilters[i];
            relevantParent.values = e.target.value;

            if (filterCondtion && filterCondtion?.useRelevant && filterCondtion?.useRelevant.length && !allDeselected) {

                for (let rel of filterCondtion?.useRelevant) {
                    for (let indx = 0; indx < reportDetails[reportIndex]?.reportFilters.length; indx++) {
                        const filter = reportDetails[reportIndex]?.reportFilters[indx]
                        if (rel?.relevantMember === filter?.member) {

                            if (!e?.target?.value.length) {
                                filter.mode = "unSelectAll"
                                filter.relevantValues = []
                                updateReportDetails(reportDetails)

                            } else {
                                filter.isDisabled = true
                                updateReportDetails(reportDetails)
                                promiseArr.push(handleCubeDataFetch(filter, 'onChange'))
                            }
                        }
                    }
                }
                if (promiseArr.length) {
                    Promise.all(promiseArr).then(data => {
                        if (data && data?.length) {
                            let i = 0;
                            for (let rel of filterCondtion?.useRelevant) {
                                for (let indx = 0; indx < reportDetails[reportIndex]?.reportFilters.length; indx++) {
                                    const filter = reportDetails[reportIndex]?.reportFilters[indx]
                                    if (rel?.relevantMember === filter?.member) {
                                        filter.relevantValues = []
                                        filter.relevantValues = data[i];
                                        if (filter?.values?.length) {
                                            filter.values = filter.values.filter(f => f && filter.relevantValues.includes(f))
                                        }
                                        filter.isDisabled = false
                                        reportDetails[reportIndex].reportFilters[indx] = filter
                                    }
                                }
                                i++;
                            }
                        }
                        updateReportDetails(reportDetails)
                    })
                }
            }
            else {
                updateReportDetails(reportDetails)
            }
        }
        else {
            let promiseArr = []
            reportDetails.reportDetails.reportFilters[i].values = e.target.value;
            // const relevantParent = reportDetails.reportDetails.reportFilters[i];
            // relevantParent.values = e.target.value;

            if (filterCondtion && filterCondtion?.useRelevant && filterCondtion?.useRelevant.length && !allDeselected) {

                for (let rel of filterCondtion?.useRelevant) {
                    for (let indx = 0; indx < reportDetails?.reportDetails?.reportFilters?.length; indx++) {
                        const filter = reportDetails?.reportDetails?.reportFilters[indx]
                        if (rel?.relevantMember === filter?.member) {

                            if (!e?.target?.value.length) {
                                filter.mode = "unSelectAll"
                                filter.relevantValues = []
                                updateReportDetails({ reportDetails: reportDetails.reportDetails })

                            } else {
                                filter.isDisabled = true
                                updateReportDetails({ reportDetails: reportDetails.reportDetails })

                                promiseArr.push(handleCubeDataFetch(filter, 'onChange'))
                            }
                        }
                    }
                }
                if (promiseArr.length) {
                    Promise.all(promiseArr).then(data => {
                        if (data && data?.length) {
                            let i = 0;
                            for (let rel of filterCondtion?.useRelevant) {
                                for (let indx = 0; indx < reportDetails?.reportDetails?.reportFilters.length; indx++) {
                                    const filter = reportDetails?.reportDetails?.reportFilters[indx]
                                    if (rel?.relevantMember === filter?.member) {
                                        filter.relevantValues = []
                                        filter.relevantValues = data[i];
                                        if (filter?.values?.length) {
                                            filter.values = filter.values.filter(f => f && filter.relevantValues.includes(f))
                                        }
                                        filter.isDisabled = false
                                        reportDetails.reportDetails.reportFilters[indx] = filter
                                    }
                                }
                                i++;
                            }
                        }
                        updateReportDetails({ reportDetails: reportDetails.reportDetails })
                    })
                }
            }
            else {
                // cascadeDeselect(reportDetails?.reportDetails?.reportFilters, i)

                const filters = cascadeDeselect(reportDetails?.reportDetails?.reportFilters, i)
                reportDetails.reportDetails.reportFilters = filters

                updateReportDetails({ reportDetails: reportDetails.reportDetails })
            }
        }
    }

    function cascadeDeselect(reportFilters, i) {
        const filter = reportFilters[i]
        if (filter?.useRelevant && filter?.useRelevant?.length) {
            for (let rel of filter?.useRelevant) {
                for (let indx = 0; indx < reportFilters.length; indx++) {
                    const filter = reportFilters[indx]
                    if (rel?.relevantMember === filter?.member) {
                        filter.mode = "unSelectAll"
                        filter.relevantValues = []
                        filter.values = []
                        reportFilters[indx] = filter
                        cascadeDeselect(reportFilters, indx)
                    }
                }
            }
        }
        return reportFilters
    }

    const handleMultiSelect = (filterCondtion, i, e, reportIndex) => {
        if (filterCondtion?.values.length) {
            !filterCondtion?.values?.some(ele => ele === e?.target?.value[0]) ? e.target.value = [...e.target.value, ...filterCondtion?.values] : e.target.value = filterCondtion?.values.filter(ele => ele !== e.target.value[0])
        }
        handleChangeFilterFromListHandler(filterCondtion, i, e, reportIndex)
    }


    const handleSelectAll = (event) => {
        event.stopPropagation();
        let e = { target: { value: 'all' } };
        handleChangeFilterFromListHandler(filterCondtion, i, e, reportIndex)
    }

    const handleUnSelectAll = (event) => {
        event.stopPropagation();
        let e = { target: { value: null } };
        handleChangeFilterFromListHandler(filterCondtion, i, e, reportIndex)
    }

    const MultiSelectRow = ({ index, style, data }) => {
        let label = data[index];
        let value = data[index];

        if (filterCondtion?.dynamicLabel) {
            const item = data[index];
            label = item[filterCondtion?.dynamicLabel?.label]
            value = item[filterCondtion?.member]
        }

        return <div style={style} key={value}>
            <MenuItem title={label} onClick={e => handleMultiSelect(filterCondtion, i, { target: { value: [value] } }, reportIndex)} className="menu-item flex" value={value}>
                <Checkbox className="form_checkbox" checked={filterCondtion?.values?.indexOf(value) > -1} />
                <ListItemText className="text-plain" primary={label} />
            </MenuItem>
        </div>
    }

    const handleCubeDataFetch = async (filterCondtion, type = undefined) => {

        if (filterCondtion?.specificValue) {
            let valueList = [...filterCondtion?.valuesList];
            filterCondtion?.values?.map((obj) => {
                if (obj) {
                    let index = valueList?.findIndex(data => data === obj);

                    if (index < 0)
                        valueList.push(obj);
                }
            });

            if (filterCondtion?.dynamicLabel) {
                valueList = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, undefined, "filterDynamicLabel", filterCondtion?.dynamicLabel);
            }

            if (type === 'onChange') {
                return valueList
            }
            else {
                setFechData([...valueList]);
            }
        } else {
            let fetchedData;
            let filterArr = []
            if (type && filterCondtion?.relevantTo) {

                if (from === 'dashboard') {

                    const relevParent = reportDetails[reportIndex]?.reportFilters?.find(filter => filter?.member === filterCondtion?.relevantTo);
                    filterArr.push({
                        member: relevParent?.member,
                        operator: relevParent?.operator,
                        values: relevParent?.values
                    })

                    if (filterCondtion?.dynamicLabel) {
                        fetchedData = getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr, "filterDynamicLabel", filterCondtion?.dynamicLabel);

                    } else {
                        fetchedData = getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr);
                    }

                }
                else {
                    const relevParent = reportDetails?.reportDetails?.reportFilters?.find(filter => filter?.member === filterCondtion?.relevantTo);
                    filterArr.push({
                        member: relevParent?.member,
                        operator: relevParent?.operator,
                        values: relevParent?.values
                    })
                    if (filterCondtion?.dynamicLabel) {
                        fetchedData = getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr, "filterDynamicLabel", filterCondtion?.dynamicLabel);

                    } else {
                        fetchedData = getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr);
                    }
                }
            }
            else if (filterCondtion?.relevantTo) {

                fetchedData = await handleInitialRelevantValues()
            }

            else {

                if (filterCondtion?.dynamicLabel) {
                    fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, undefined, "filterDynamicLabel", filterCondtion?.dynamicLabel);
                } else {
                    fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType);
                }


                filterCondtion.relevantValues = []
                filterCondtion.mode = 'onMount'
                if (from === 'dashboard') {
                    updateReportDetails(reportDetails)
                }
                else {
                    updateReportDetails({ reportDetails: reportDetails.reportDetails })
                }

                filterCondtion?.values?.map((obj) => {
                    if (obj) {
                        let index = fetchedData && fetchedData.findIndex(data => data === obj);
                        if (index < 0)
                            fetchedData.push(obj);
                    }
                });
            }

            if (fetchedData) {
                if (type === 'onChange') {
                    return fetchedData
                }
                else {
                    setFechData([...fetchedData]);
                }
            }
        }

    }

    const handleInitialRelevantValues = async () => {
        let fetchedData
        let filterArr = []
        if (from === 'dashboard') {

            const relevParent = reportDetails[reportIndex]?.reportFilters?.find(filter => filter?.member === filterCondtion?.relevantTo);
            if (relevParent?.values && relevParent?.values.length) {

                filterArr.push({
                    member: relevParent?.member,
                    operator: relevParent?.operator,
                    values: relevParent?.values
                })
                if (filterCondtion?.dynamicLabel) {
                    fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr, "filterDynamicLabel", filterCondtion?.dynamicLabel);

                } else {
                    fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr);
                }
            }
        }
        else {
            const relevParent = reportDetails?.reportDetails?.reportFilters?.find(filter => filter?.member === filterCondtion?.relevantTo);
            if (relevParent?.values && relevParent?.values.length) {

                filterArr.push({
                    member: relevParent?.member,
                    operator: relevParent?.operator,
                    values: relevParent?.values
                })
                if (filterCondtion?.dynamicLabel) {
                    fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr, "filterDynamicLabel", filterCondtion?.dynamicLabel);
                } else {
                    fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, filterArr);
                }
            }
            else {
                fetchedData = []
            }
        }
        return fetchedData
    }

    const handleFilterSearchInput = async (e, cb) => {
        e.stopPropagation();
        const value = e?.target?.value
        if (value === "") {
            setSearchData([])
            setSearchLoader(false)
        }
        else {
            let filterQuery = [{
                member: filterCondtion?.member,
                operator: 'contains',
                values: [value]
            }]
            let query = {}
            if (filterCondtion?.dataSetType === 'MEASURE') {
                query['measures'] = [filterCondtion?.member]
            }
            else if (filterCondtion?.dataSetType === "DIMENSION") {
                query['dimensions'] = [filterCondtion?.member]
            }
            query.filters = filterQuery

            const searchValues = await getDataFromCube(null, null, null, "custom_query_data", query)
            const fData = searchValues?.map(f => f[filterCondtion?.member])
            cb(fData)
            setSearchLoader(false)
        }
    };
    const debouncedFetchData = _.debounce((e, cb) => {
        setSearchLoader(true)
        handleFilterSearchInput(e, cb);
    }, 500);


    const handleFilterOnClose = () => {
        setSearchData([])
        setSearchLoader(false)
        setFilterInputOpen(false);
    }

    const generateOptions = () => {
        if (!filterCondtion?.relevantValues?.length && filterCondtion?.mode === "unSelectAll") {
            return []
        }
        else if (filterCondtion?.relevantValues?.length) {
            return filterCondtion?.relevantValues
        }
        else if (filterCondtion?.relevantTo && filterCondtion.mode === 'onMount') {
            return []
        }
        else {
            return fechData
        }
    }



    const getFilterLabel = (displayName) => {
        if (displayName && displayName?.includes('select') || displayName?.includes('Select') || displayName?.includes('SELECT')) {
            return displayName;
        }
        else {
            return `Select ${displayName}`;
        }
    }

    const filterIdRef = useRef(null);
    useEffect(() => {
        if (!filterIdRef.current) {
            handleCubeDataFetch(filterCondtion)
            filterIdRef.current = filterCondtion?._id
        }
    }, [filterCondtion]);

    return (
        <>
            <Box className="sheet-filter-view-item">
                {((filterCondtion?.isDisabled || searchLoader) && onLoader) && <Loader className="sheet-filter-item-loader" />}
                <Select
                    className="report_form_ui_input_select pl-0"
                    variant="outlined"
                    multiple
                    open={filterInputOpen}
                    onOpen={(e) => setFilterInputOpen(true)}
                    onClose={handleFilterOnClose}
                    value={filterCondtion?.values && filterCondtion?.values.length ? [...new Set(filterCondtion?.values)] : [getFilterLabel(filterCondtion?.displayName)]}
                    renderValue={(selected) => selected && selected.length === 1 ? selected[0] : `${filterCondtion?.displayNameOnSheet || filterCondtion?.displayName || filterCondtion?.member?.split('.')[1]} (${selected.length})`}
                    //label={filterCondtion?.displayName }
                    size='small'
                    IconComponent={DropDownIcon}
                    disabled={filterCondtion?.isDisabled}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                        },
                        getcontentanchorel: null,
                        classes: { paper: 'filters-view-popover' }
                    }}

                >
                    <Box className="filters-dropdown-item dasboard-filters-view-dropdown">
                        <Box className="filters-dropdown-item-header" display="flex" justifyContent="space-between">
                            <InputLabel className="filters-dropdown-item-label" htmlFor="outlined-age-native-simple">&#8288;{filterCondtion?.displayNameOnSheet || filterCondtion?.displayName || filterCondtion?.member?.split('.')[1]}</InputLabel>
                            <IconButton className="form-icon-btn filter-close-icon" color="secondary" onClick={e => handleFilterOnClose(e)}>
                                <img src={CancelButton} className="" />
                            </IconButton>
                        </Box>
                    </Box>
                    <TextField className=" cm_rprt_setting_content form_input_outline dasboard-filters-view-dropdown-search" type="search" size="medium" placeholder="Search..."
                        onChange={e => debouncedFetchData(e, res => {
                            setSearchData(res)
                        })}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="start">
                                    <InputSearchIcon className="input_search_icon" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    {/* {  _.isEqual(filterCondtion.values,
                    filterCondtion.dynamicLabel ? (searchData?.length ? searchData : fechData)?.map(e => e && e[Object.keys(e)?.filter( p => p !== filterCondtion?.dynamicLabel?.label )]) : (searchData?.length ? searchData : fechData)) ? <div className={classes.header}>
                    <Paper className={classes.card} elevation={3}>
                        <Button className='report_form_ui_btn primary' size='small' variant="outlined" onClick={handleUnSelectAll} >UnSelect All
                        </Button>
                    </Paper>
                </div> :
                (filterCondtion.selectAll ? <div className={classes.header}>
                    <Paper className={classes.card} elevation={3}>
                        <Button className='report_form_ui_btn primary' size='small' variant="outlined" onClick={handleSelectAll} >Select All</Button>
                    </Paper>
                </div> : null)} */}
                    <Box className="filters-view-checbox-toggle">
                        {
                            (filterCondtion.selectAll ? <div>
                                <Paper className={" filters_filter_paper filters-view-checbox-paper"} >
                                    <FormControlLabel style={{padding: "0 9px"}} className="filters-view-checkbox" control={<Checkbox className="form_checkbox " checked={(_.isEqual(filterCondtion.values, filterCondtion.dynamicLabel ? (searchData?.length ? searchData : fechData)?.map(e => e && e[Object.keys(e)?.filter(p => p !== filterCondtion?.dynamicLabel?.label)]) : (searchData?.length ? searchData : fechData)))}
                                        onChange={(_.isEqual(filterCondtion.values, filterCondtion.dynamicLabel ? (searchData?.length ? searchData : fechData)?.map(e => e && e[Object.keys(e)?.filter(p => p !== filterCondtion?.dynamicLabel?.label)]) : (searchData?.length ? searchData : fechData))) ? handleUnSelectAll : handleSelectAll} />} label="Select All" />
                                </Paper>
                            </div> : null)
                        }
                    </Box>

                    <div className={`virtual-filter-div ` + ((searchData.length || generateOptions().length) ? 'filter-data-exists' : ``)}>
                        <AutoSizer>
                            {({ height, width }) => (
                                <List
                                    className="List"
                                    height={(searchData.length ? searchData : generateOptions()).length ? height : 20}
                                    itemCount={(searchData.length ? searchData : generateOptions()).length}
                                    width={width - 6}
                                    itemData={(searchData.length ? searchData : generateOptions())}
                                    itemSize={35}
                                >
                                    {MultiSelectRow}
                                </List>
                            )}
                        </AutoSizer>
                    </div>

                </Select>
            </Box>
        </>
    )
}
